export default {
    'todoList': 'My Tasks',
    'comments': 'Common Approval Comments',
    'toggleBatch': 'batch process',
    'toggleStandalone': 'Toggle standalone mode',
    'toreadList': 'To-read Task',
    'batchApprove': 'Batch Approve',
    'doneList': 'My Finished',
    'readList': 'Finished Read',
    'batchWaiting': 'task loading,please wait...',
    'approveSuggestion': 'Comments',
    'transferInstructions': 'Transfer Instructions',
    'batchOk': 'I Know',
    'onlySupportMobileWrite': "signature only support mobile write",
    'batchHandle': 'Batch Handle',
    'myFlow': 'My Running',
    'delegationFlow': 'Workflow Delegation',
    'delegationToMe': 'Delegation to Me',
    'delegationReport': 'Delegation Report',
    'action': 'action',
    'entrusted': 'Entrusted',
    'delegationProcess': 'Workflow Delegation',
    'selectAll': 'Choose all',
    'searchFlow': 'Workflow Search',
    'instanceSearch': 'Workflow Instance Search',
    'taskSearch': 'Task Search',
    'startFlow': 'Start a workflow',
    'batchHandleFlow': 'Batch Approval',
    'batchAgree': 'Batch Approval',
    'uploadFile': 'Upload File',
    'batchTransfer': 'Batch Transfer',
    'searchFlowPlaceholder': 'Search workflow name/originator',
    'orderNuber': 'NO.',
    'flowName': 'Workflow Name',
    'workflowName': 'Template Name',
    'curActivity': 'Current Activities',
    'currentDisplay': 'Current Display',
    'stayTime': 'Stay Time',
    'day': 'Day',
    'days': 'Days',
    'hour': 'hour',
    'hours': 'hours',
    'min': 'min',
    'mins': 'mins',
    'lessThan': 'less than 1 minute',
    'originatorName': 'Creator',
    'departmentName': 'Dept. Of Originator',
    'timeout': 'Timeout',
    'overtime': 'Timeout',
    'aboutToTimeout': 'About to timeout',
    'noDataText': 'No Task List',
    'searchNoDataText': 'No result',
    'loadFailedText': 'Faild to load',
    'refresh': 'Refresh',
    'filter': 'Filter',
    'batchApproval': 'Batch Approval',
    'circulated': 'read',
    'flowType': 'Workflow Type',
    'sourceName': 'Circulate Source',
    'reciveTime': 'Receive Time',
    'flowTemplate': 'Workflow mode',
    'startTime': 'Start Time',
    'endTime': 'End Time',
    'processing': 'Processing',
    'completed': 'Completed',
    'canceled': 'Canceled',
    'draft': 'Draft',
    'exception': 'Exception',
    'flowStatus': 'Workflow Status',
    'more': 'More',
    'add': 'Add',
    'delete': 'Delete',
    'edit': 'Edit',
    'collapse': 'Fold',
    'reset': 'Reset',
    'search': 'Search',
    'ok': 'Ok',
    'cancel': 'Cancel',
    'deleteTrustTips1': 'Are you sure want to delete this delegation?',
    'deleteTrustTips2': 'The delegation is invalid after deletion, the delegated party will no longer approve/initiate the process.',
    'deleteFailed': 'Delete failed, please try again',
    'deleteSuccess': 'Delete successful',
    'timeRange': '{start} to {end}',
    'plzSelect': 'Please select',
    'resolveTime': 'Action Time',
    'approvalNode': 'Activity Name',
    'resolveRzt': 'Action',
    'noContent': 'No result',
    'initiationTime': 'Start Time',
    'cancelTime': 'Cancel Time',
    'resolver': 'Approver',
    'curResolver': 'Current Approver',
    'usedTime': 'Elapsed time',
    'originatorDepartment': 'Dept. Of Originator',
    'finishedTime': 'Completed Time',
    'costTime': 'Cost Time',
    'state': 'State',
    'all': 'All',
    'systemTransfer': 'System Transfer',
    'noStarted': 'Unopened',
    'resolving': 'Resolving',
    'beCancled': 'Cancled',
    'searchFlowName': 'Search workflow name',
    'mycollect': 'My Collect',
    'histrory': 'Recently Used',
    'startWorkflowHint': 'Reminders: 1. Inquire about the process you want to initiate, and click on the process to initiate; 2. You can add favorites to frequently used processes; 3. The most recently used 20 processes are displayed in common processes by default',
    'searchRzt': 'Search result',
    'items': 'items',
    'showAll': 'The load completed',
    'reason': 'Reason',
    'commonFlow': 'Commonly used',
    'setSevenFlows': 'Limited to 7',
    'flowItems': 'item(s)',
    'setCommon': 'Set to Commonly use',
    'cancelCommon': 'Cancel the Commonly use',
    'sevenFlowsIsMost': 'Limited set to 7',
    'timeOutAfter': 'later,it will timeout',
    'beUrged': 'Urged',
    'total': 'Total {num} items',
    'total2': 'Total',
    'strip': 'item',
    'sequenceNo': 'Sequence No',
    // 二开开始
    'applicationNo': 'Application No.',
    'Action': 'Action',
    // 二开结束
    'trusteeName': 'Delegate To',
    'workflowNode': 'Workflow Node',
    'inputSequenceNo': 'Input sequenceNo',
    'inputWorkflowNode': 'Input Workflow Node',
    'adminNewWorkflowErr': 'Admin cannot initiate workflow!',
    'crossOriginator': 'BBA Creator',
    'crossOriginatorPlaceholder': 'Please Input Name or Account',
    'approval': {
        'agree': 'Approve',
        'reject': 'Reject',
        'forward': 'Transfer',
        'canceled': 'Canceled',
        'undo': 'Processing'
    },
    'workflowState': {
        'draft': 'Draft',
        'processing': 'Processing',
        'completed': 'Completed',
        'canceled': 'Canceled',
        'exception': 'Exception',
    },
    'showAllTodo': 'Search completed',
    'showAllDone': 'Loading completed!',
    'showAllToRead': 'Search completed!',
    'showAllRead': 'Loading completed',
    'showAllResult': 'Loading completed',
    'showAllSearch': 'Search completed',
    'item': 'item(s)',
    'delegation': {
        // 'client': 'Client',
        'client': 'Original Approver',
        // 'consignor': 'Consignor',
        'consignor': 'Delegate To',
        'delegateType': 'Delegate type',
        'entrustedPeriod': 'Time Range',
        'operation': 'Operation',
        'workflowApproval': 'Process approval',
        'startWorkflow': 'Process initiation',
        'workflowScope': 'Select Process',
        "workflowTrusts": 'Select Process',
        'comments': 'Comments',
        'isNotification': 'Yes',
        'NoNotification': 'No',
        'notification': 'Notification to Original Approver',
        'notificationTitle': 'Receive Notification',
        'workflowName': 'Process Name',
        'all': 'All',
        'wholeProcess': 'Whole process',
        'partProcess': 'Part of the process',
        'addDelegation': 'Add Delegation',
        'editDelegation': 'Edit Delegation',
        'createDelegationTips1': 'Please complete the current entrustment information',
        'createDelegationTips2': 'Modify delegation succeeded!',
        'createDelegationTips3': 'Process delegation time overlap',
        'createDelegationTips4': 'Create delegation succeeded!',
        'createDelegationTips5': 'The delegation period should be within one year.',
    },
    'TemplateContent': 'Template Content',
    'createdBy': 'CreatedBy',
    'createdTime': 'CreatedTime',
    'batchDelete': 'Batch Delete',
    'pleaseEnter': 'Please input',
    'userCard': {
        'organization': 'Organization',
        'jobNumber': 'No.',
        'position': 'Position',
        'role': 'Role',
        'dingTalkCall': 'DingTalk conversation',
    },
    // 快捷审批
    fastApproval: {
        approval: 'Approval',
        fastApproval: 'Quick Approval',
        comment: 'Comment',
        opinion: 'Opinion',
        reject: 'Reject',
        approve: 'Approve',
        detail: 'Detail',
        placeholder: 'Please put your refuse reason,if you approve this application,you also can put your reason.',
        placeholderApprove: 'Please put your reason for approval',
        placeholderDecline: 'Please put your reason for reject',
        allTips: 'All: All pending tasks. ',
        quickTabTips: 'Quick Approval: You can approve directly on task list without opening the form.',
        batchTabTips: ' Batch Approval: You can approve multiple tasks in batch.',
        noQuickTaskTips: 'You do not have any pending tasks that support quick approval.',
        noBatchTaskTips: 'You do not have any pending tasks that support batch approval.',
    }
};
